/* Extension Haus custom GA4 funnel events - no PII */
(function(){
  if(window.__ehAnalyticsBound) return;
  window.__ehAnalyticsBound=true;

  function send(name,params){
    params=params||{};
    params.page_path=location.pathname;
    params.eh_site='extension_haus';
    try{
      if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish==='function'){
        Shopify.analytics.publish(name,params);
      }
    }catch(e){}
  }

  function oncePerPage(key,name,params){
    var k='eh_ga_'+key+'_'+location.pathname;
    if(sessionStorage.getItem(k)) return;
    sessionStorage.setItem(k,'1');
    send(name,params);
  }


  function trackConfirmedForm(form,success,name,params){
    var key='eh_pending_'+name+'_'+location.pathname;
    if(success){
      var pending=sessionStorage.getItem(key);
      if(pending){
        sessionStorage.removeItem(key);
        try{send(name,JSON.parse(pending));}catch(e){}
      }
      return;
    }
    if(!form) return;
    form.addEventListener('submit',function(event){
      // Run after the other submit handlers so canceled requests stay attempts.
      Promise.resolve().then(function(){
        if(event.defaultPrevented) return;
        var values=params?params():{};
        sessionStorage.setItem(key,JSON.stringify(values));
        send(name+'_attempt',values);
      });
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    if(location.pathname==='/pages/professional-pricing-application'){
      oncePerPage('pro_application_view','eh_pro_application_view');
      var proForm=document.getElementById('ContactForm');
      if(proForm){
        var started=false;
        proForm.addEventListener('input',function(){
          if(!started){started=true;send('eh_pro_application_start');}
        },{passive:true});

      }
      trackConfirmedForm(proForm,document.getElementById('ehProApplicationSuccess'),'eh_pro_application_submit');
    }

    if(location.pathname==='/pages/create-your-custom-shade'){
      oncePerPage('custom_color_view','eh_custom_color_view');
      var customForm=document.getElementById('CustomShadeRequestForm');
      if(customForm){
        var customStarted=false;
        customForm.addEventListener('change',function(){
          if(!customStarted){customStarted=true;send('eh_custom_color_start');}
        },{passive:true});

      }
      trackConfirmedForm(customForm,document.getElementById('ehOrderSuccess'),'eh_custom_color_submit',function(){
        return {
          hair_type:(document.getElementById('ehHairType')||{}).value||'',
          collection:(document.getElementById('ehCollection')||{}).value||'',
          texture:(document.getElementById('ehTexture')||{}).value||''
        };
      });
      var publicForm=document.querySelector('.eh-public-custom-card form');
      trackConfirmedForm(publicForm,publicForm && publicForm.querySelector('.eh-order-success'),'eh_custom_match_submit');
    }

    document.addEventListener('toggle',function(e){
      var d=e.target;
      if(d && d.matches && d.matches('.eh-special-texture') && d.open){
        send('eh_special_texture_open');
      }
    },true);

    document.addEventListener('submit',function(e){
      var f=e.target;
      if(f && f.id==='SpecialTextureRequestForm'){
        var t=f.querySelector('[name="contact[Requested texture]"]');
        send('eh_special_texture_submit',{texture:t?t.value:''});
      }
    },true);

    document.addEventListener('click',function(e){
      var a=e.target.closest && e.target.closest('a');
      if(!a) return;
      var href=a.getAttribute('href')||'';
      if(href.indexOf('topknotsalon.glossgenius.com')!==-1){
        send('eh_book_top_knot_click',{link_text:(a.textContent||'').trim().slice(0,80)});
      }
      if(href.indexOf('/pages/professional-pricing-application')!==-1){
        send('eh_pro_application_cta_click',{link_text:(a.textContent||'').trim().slice(0,80)});
      }
      if(href.indexOf('/pages/create-your-custom-shade')!==-1){
        send('eh_custom_color_cta_click',{link_text:(a.textContent||'').trim().slice(0,80)});
      }
    },true);
  });
})();